import router from '@/router'
import { esAdminErp } from '@/vendedora/constantes'

export default {
  namespaced: true,

  state: {
    accessToken: null,
    perfil: null,
    chatActivo: null,
  },

  mutations: {
    SET_SESION (state, { accessToken, perfil }) {
      state.accessToken = accessToken
      state.perfil = perfil
    },
    SET_CHAT_ACTIVO (state, chat) {
      state.chatActivo = chat
    },
    PATCH_CHAT_ACTIVO (state, patch) {
      if (!state.chatActivo) return
      state.chatActivo = { ...state.chatActivo, ...patch }
    },
    SALIR (state) {
      state.accessToken = null
      state.perfil = null
      state.chatActivo = null
    },
  },

  actions: {
    guardarSesion ({ commit }, row) {
      commit('SET_SESION', {
        accessToken: row && row.accessToken,
        perfil: row,
      })
      router.push({ name: 'VendedoraListaChats' }).catch(() => {})
    },
    setChatActivo ({ commit }, chat) {
      commit('SET_CHAT_ACTIVO', chat)
    },
    patchChatActivo ({ commit }, patch) {
      commit('PATCH_CHAT_ACTIVO', patch)
    },
    salir ({ commit }) {
      commit('SALIR')
      router.push({ name: 'Login' }).catch(() => {})
    },
  },

  getters: {
    getLogeadoVendedora (state) {
      return !!state.accessToken
    },
    getPerfilVendedora (state) {
      return state.perfil
    },
    getAccessTokenVendedora (state) {
      return state.accessToken
    },
    getChatActivo (state) {
      return state.chatActivo
    },
    getIderp (state) {
      const p = state.perfil
      if (!p) return null
      const v = p.iderp != null ? p.iderp
        : (p.id_usuario != null ? p.id_usuario
          : (p.idusuario != null ? p.idusuario : null))
      if (v == null || v === '') return null
      const n = Number(v)
      return Number.isFinite(n) ? n : v
    },
    getEsAdminVendedora (state, getters) {
      return esAdminErp(getters.getIderp)
    },
  },
}
